import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import React, { useEffect } from 'react';

gsap.registerPlugin(ScrollTrigger);

interface AnimatedTextProps {
  text: string;
  bgColor: string;
  fgColor: string;
}

const AnimatedText: React.FC<AnimatedTextProps> = ({
  text,
  bgColor,
  fgColor,
}) => {
  useEffect(() => {
    gsap?.fromTo(
      '.reveal-type span',
      { color: bgColor },
      {
        color: fgColor,
        duration: 0.3,
        delay: (i) => i * 0.1,
        scrollTrigger: {
          trigger: '.reveal-type',
          start: 'top 80%',
          end: 'top 20%',
          scrub: true,
        },
      },
    );
  }, [text, bgColor, fgColor]);
  const charArray = text.split('');
  return (
    <span className='reveal-type '>
      {charArray.map((char, index) => (
        <span
          className='text-3xl lg:text-5xl xl:text-[64px] font-medium leading-10 text-fa'
          key={`${char}-${index}`}
          style={{ color: bgColor }}
        >
          {char}
        </span>
      ))}
    </span>
  );
};

const AnimatedSections: React.FC = () => {
  return (
    <>
      <section className='md:w-4/5 xl:w-8/12'>
        <AnimatedText
          text='We make Books with cutting-edge Design & Technology inside to simplify complex topics, so you read easily, apply directly and retain 5x more!'
          bgColor='#7D7D7D'
          fgColor='#FFFFFF'
        />
      </section>
    </>
  );
};

export default AnimatedSections;
